import { useCallback } from "react";

import { useAuthSelector, userAllRolesSelector, userRoleSelector } from "core/stores/authStore";

import binaryToFlags from "core/helpers/common/binaryToFlags";

import { USER_ROLE } from "core/constants/auth";

const useRole = () => {
	const allRoles = useAuthSelector(userAllRolesSelector);
    const userRole = useAuthSelector(userRoleSelector);

	const hasRole = useCallback(role => {
        const roles = binaryToFlags(Object.values(USER_ROLE), allRoles);
        return roles.includes(role);
    }, [allRoles])

    const hasMainRole = useCallback(role => role === userRole, [userRole])

    return {
        hasRole,
        hasMainRole
    }
}

export default useRole;